import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/store";
import BootstrapVue from "bootstrap-vue";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Multiselect from "vue-multiselect";
import "@/assets/css/custom.css";
import VueSuggestion from "vue-suggestion";

Vue.use(VueSuggestion);
Vue.use(BootstrapVue);
Vue.use(PaperDashboard);

Vue.use(BootstrapVue);
Vue.use(PaperDashboard);
library.add(faUserSecret);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("multiselect", Multiselect);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: "/login"
      });
    } else {
      if (
        store.getters.getAccessLevel == 2 ||
        store.getters.getAccessLevel == 3 ||
        store.getters.getAccessLevel == 4 ||
        store.getters.getAccessLevel == 5
      ) {
        if (store.getters.loggedIn) {
          next({
            path: "/dashboardUser"
          });
        } else {
          // next();
        }
      } else if (store.getters.getAccessLevel == 1) {
        next();
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
